import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PaidSupplierService } from './paid-supplier.service';

@Component({
  selector: 'app-supplier-verification-dialog',
  templateUrl: './supplier-verification-dialog.component.html',
  styleUrls: ['./supplier-verification-dialog.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class SupplierVerificationDialogComponent implements OnInit {
  showModal = false;

  constructor(private paidSupplierService: PaidSupplierService) {}

  ngOnInit(): void {
    this.paidSupplierService.isModalVisible$.subscribe((visible) => {
      this.showModal = visible;
    });
  }

  confirmLaunch() {
    this.paidSupplierService.confirmLaunch();
  }

  closeModal() {
    this.paidSupplierService.closeModal();
  }
}
